// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SharableProfile-module-shareProfile-3UO9B{width:32px;height:32px}", ""]);
// Exports
exports.locals = {
	"shareProfile": "SharableProfile-module-shareProfile-3UO9B"
};
module.exports = exports;
